/*
	This component manages the state of the flooring enquiry form, including selected options and syncs with hidden HubSpot fields.
*/

export const flooringEnquiry = ({title, url, colours, thickness}) => ({
	title,
	url,
	colours: colours,
	thickness: thickness,
	selectedColour: null,

	init() {
		// Set default options on page load
		//
		setTimeout(() => {
			this.selectedColour = this.normalizeColour(this.colours[0])
		}, 1000)

		this.$watch('selectedColour', () => {
			this.updateHsColourField()

			window.dispatchEvent(new CustomEvent('flooringColourUpdated', {
				detail: {
					selectedColour: this.selectedColour,
				}
			}))
		})

		this.setHsProductTitleField()
		this.setHsThicknessField()
	},

	selectColour(colour) {
		this.selectedColour = this.normalizeColour(colour)
	},

	normalizeColour(colour) {
		if (!colour) return null
		if (typeof colour === 'string') {
			return colour
		}
		return colour.title || null
	},

	setHsProductTitleField() {
		const hsTitleField = document.querySelector('input[name="hs_product_title"]')

		if (hsTitleField) {
			hsTitleField.value = this.title || ''
		}
	},

	setHsThicknessField() {
		const hsThicknessField = document.querySelector('input[name="hs_thickness"]')
		if (hsThicknessField) {
			hsThicknessField.value = this.thickness || ''
		}
	},

	updateHsColourField() {
		const hsColourField = document.querySelector('input[name="hs_colour"]')
		if (hsColourField) {
			hsColourField.value = this.selectedColour || ''
		}
	},

	get variantOptionsString() {
		const options = []

		if (this.selectedColour) {
			options.push(this.selectedColour)
		}

		return options.join(', ')
	}
})
